module.exports = __webpack_public_path__ + "static/media/onboardingTwoPeopleSmall.a2c9e3bc.png";